import React from 'react'
import LocalShipping from '@mui/icons-material/LocalShipping';
import PriorityLevelHierarchyList from './HierarchyList';
import PriorityLevelFlatList from './FlatList';
import FlatEdit from './FlatEdit';
import PriorityLevelList from './HierarchyList';
import HierarchyEdit from './HierarchyEdit';
import Create from './Create'

//false
const isHierarchy = false; // expects true or false injected by plop

const listComponent = isHierarchy
  ? PriorityLevelHierarchyList
  : PriorityLevelFlatList;


const editComponent = isHierarchy
  ? HierarchyEdit
  : FlatEdit;

const conf = {
    name: 'kelloggs_priority_level',
    icon: <LocalShipping />,
    list: listComponent,
    edit: editComponent,
    create: Create,
    options: {
        label: "Priority Level",
        items: true
    }
};

export default conf;